// extracted by mini-css-extract-plugin
export var infoItem = "_mx-2";
export var title = "_mx-0";
export var value = "_mx-1";